// extracted by mini-css-extract-plugin
export default {"button":"ConferenceRecommender_button__Ml53r","rounded":"ConferenceRecommender_rounded__1XBl8","roundCheckbox":"ConferenceRecommender_roundCheckbox__ZQbZn"};